import {
    EXPORT_ORDER_DONE,
    LOADING,
    SET_DO_EXPORT_DONE,
    SET_DO_EXPORT_ERROR,
    SET_LOADING_REPORT_HISTORY_DONE,
    SET_LOADING_REPORT_HISTORY_ERROR
} from "./orderExportType";
import {displayError, displaySuccessMessage} from "../../common/notifications";
import {doGenerateReportClick} from "../../api/api";

export const setDoExportDone = (res) => {
    return {
        type: SET_DO_EXPORT_DONE,
        msg: res,
        loading: false,
        loadingBtn:false
    };
};

export const setLoadingReportHistoryDone = (res) => {
    return {
        type: SET_LOADING_REPORT_HISTORY_DONE,
        msg: res,
        loading: false
    };
};


export const setLoadingReportHistoryError = (res) => {
    return {
        type: SET_LOADING_REPORT_HISTORY_ERROR,
        msg: res,
        loading: false,
        loadingBtn:false
    };
};

export const setDoExportError = (error) => {
    return {
        type: SET_DO_EXPORT_ERROR,
        msg: error,
        loadingBtn:false,
        loading: false
    };
};

export const setLoading =(val)=> {
    return {
        type: LOADING,
        loading: val
    }
}

export const setExportOrderDone =(res) => {
    return {
        type:EXPORT_ORDER_DONE,
        loading:false,
        data:res
    }
}

export const setDoGenerateReportClick = (from,to, reportType,currencies) => {
    return async (dispatch) => {
        try {
            var res= await doGenerateReportClick(from,to, reportType,currencies);
            dispatch(setExportOrderDone(res))
            dispatch(setDoExportDone("done"));
        } catch (e) {
            // alert(JSON.stringify(e))
            if(e.result)
                displayError(e.result);
            
            dispatch(setDoExportError(e));
        }
    }

};


